import Sorting from "../data/sorting";
import {getBasicAuthHeader} from "./auth";
import {Leaderboard} from "../data/leaderboard";
import {generateHashValue} from "./secrets";
import {Entry} from "../data/entry";

export async function createLeaderboardApiCall(name: string, sorting: Sorting): Promise<Response> {
    return await fetch(
        `/api/leaderboards`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
                name: name,
                sorting: sorting.toString(),
            }),
        },
    );
}

export async function updateLeaderboardApiCall(updatedLeaderboard: Leaderboard): Promise<Response> {
    return await fetch(
        `/api/leaderboards/${updatedLeaderboard.id}`,
        {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
                name: updatedLeaderboard.name,
                sorting: updatedLeaderboard.sorting.toString(),
            }),
        },
    );
}

export async function getLeaderboardEntriesApiCall(id: string): Promise<Response> {
    return await fetch(
        `/api/leaderboards/${id}/entries`,
        {
            method: "GET",
            credentials: "include",
        },
    );
}

export async function addLeaderboardEntryApiCall(entry: Entry, leaderboardSecret: string): Promise<Response> {
    const hash = await generateHashValue(entry.username, entry.score, leaderboardSecret);

    return await fetch(
        `/api/leaderboards/${entry.leaderboardId}/user/${encodeURIComponent(entry.username)}`,
        {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                hash: hash,
                score: entry.score,
                meta: entry.meta
            })
        },
    );
}

export async function deleteLeaderboardEntryApiCall(entry: Entry): Promise<Response> {
    return await fetch(
        `/api/leaderboards/${entry.leaderboardId}/user/${encodeURIComponent(entry.username)}`,
        {
            method: "DELETE",
            credentials: "include"
        },
    );
}

export async function getLeaderboardApiCall(id: string): Promise<Response> {
    return await fetch(
        `/api/leaderboards/${id}`,
        {
            method: "GET",
            credentials: "include",
        },
    );
}


export async function deleteLeaderboardApiCall(id: string): Promise<Response> {
    return await fetch(
        `/api/leaderboards/${id}`,
        {
            method: "DELETE",
            credentials: "include"
        },
    );
}

export async function getSessionApiCall(): Promise<Response> {
    return await fetch(
        `/api/auth/session`,
        {
            method: "GET",
        },
    );
}

export async function loginApiCall(username: string, password: string): Promise<Response> {
    const authorizationHeader = getBasicAuthHeader(username, password);

    return await fetch(
        `/api/auth/login`,
        {
            method: "POST",
            headers: {
                Authorization: authorizationHeader,
            },
        },
    )
}